var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "receipt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.943,
    height: 13.343,
    viewBox: "0 0 10.943 13.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12668",
    "data-name": "Path 12668",
    d: "M49.65,128.226c-1.986-.011-3.628-4.065-3.628-6.129,0-3.372,2.53-4.11,3.5-4.11a4.032,4.032,0,0,1,1.322.325,2.956,2.956,0,0,0,.755.216,2.349,2.349,0,0,0,.542-.176,4.342,4.342,0,0,1,1.633-.395h0a3.346,3.346,0,0,1,2.8,1.414l.2.307-.294.222a2.473,2.473,0,0,0-1.186,2.04,2.3,2.3,0,0,0,1.284,2.128c.184.111.374.225.374.474,0,.163-1.3,3.663-3.19,3.663a2.566,2.566,0,0,1-1.077-.261,2.184,2.184,0,0,0-.959-.231,2.466,2.466,0,0,0-.759.205,3.719,3.719,0,0,1-1.317.307Z",
    transform: "translate(-46.022 -114.884)",
    fill: "#8896af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12669",
    "data-name": "Path 12669",
    d: "M257.661,0a2.628,2.628,0,0,1-2.487,2.927A2.827,2.827,0,0,1,257.661,0Z",
    transform: "translate(-249.705)",
    fill: "#8896af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacIcon);
export default __webpack_public_path__ + "static/media/mac-icon.363e01abe93b0fcdad012068881c5a7a.svg";
export { ForwardRef as ReactComponent };